/** Shared tool caches contain model parameters and queued practice events, never authentication tokens. */
export const STUDY_TOOL_CACHE_PREFIX = 'study-tool-pending-v1:';

export function clearStudyToolCaches(): void {
  try {
    const keys = Array.from({ length: localStorage.length }, (_, index) => localStorage.key(index));
    for (const key of keys) if (key?.startsWith(STUDY_TOOL_CACHE_PREFIX)) localStorage.removeItem(key);
  } catch { /* Browser storage is optional. */ }
}
